module.exports = __webpack_public_path__ + "static/media/icons8-canva.85171052.svg";